/**
* @summary - Component that Provides RI Track functionality
* @autor vengateshwaran k
* @since 2024-05-30
*/
import { Box, Grid, Typography } from "@mui/material";
import { eachWeekOfInterval, endOfMonth, format, parseISO, startOfMonth ,eachDayOfInterval,isSameDay} from 'date-fns';
import React, { useEffect, useState } from 'react';
import PpmPlannerRepository from '../../api/repositories/ppmPlannerRepository';
import { DefaultCard } from "../../assets/styled-components/card";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import RefreshExportButtons from '../commoncomponents/RefreshExportButtons';
import SquareBoxRenderer from './SquareBoxRenderer'; // Import the custom cell renderer
import ActionButtons from "../commoncomponents/ActionButtons";
import { useNavigate } from 'react-router-dom';
import PremitiveMaintenanceRepository from "../../api/repositories/premitiveMaintenanceRepository";
import PageLoader from "../commoncomponents/PageLoader";
import RoutineInspectionRepository from "../../api/repositories/routineInspectionRepository";
import { useLocation } from "react-router";
const RoutineInspectionShowSchedule = ({periodForShowSchedule,routineId, serviceType, facilityId, companyId,assetdeatils,taskCode,assetNoForShowSchedule }) => {
  const location = useLocation();
  const [gridApi, setGridApi] = useState({});
  const [getData, setGetData] = useState([]);
  const [rowData, setRowData] = useState([]);
  const [allRowData, setAllRowData] = useState([]);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  
  const generateWeeklyColumns = (month,monthname) => {
    const year=new Date().getFullYear() ;
    const startDate = startOfMonth(new Date(year, month - 1));
    const endDate = endOfMonth(new Date(year, month - 1));
    if(periodForShowSchedule==="Daily"){
    const days = eachDayOfInterval({ start: startDate, end: endDate });
    return days?.map((day, index) =>  
      ({    
      // field: `${format(index ===0 ?startOfWeek+1:startOfWeek, 'MMM').toLowerCase()}_week${index + 1}`,
      field: `${monthname}_day${index + 1}`,
      headerName: `${index + 1}`,
      flex: 2, // Adjust the flex value to increase the width
      minWidth: 100, // Adjust the minWidth value to increase the minimum width
      cellRenderer: SquareBoxRenderer, // Use the custom cell renderer
    }));}
    else{
    const weeks = eachWeekOfInterval({ start: startDate, end: endDate }, { weekStartsOn: 1 });
    return weeks?.map((startOfWeek, index) =>  
      ({    
      // field: `${format(index ===0 ?startOfWeek+1:startOfWeek, 'MMM').toLowerCase()}_week${index + 1}`,
      field: `${monthname}_week${index + 1}`,
      headerName: `${index + 1}W`,
      flex: 2, // Adjust the flex value to increase the width
      minWidth: 100, // Adjust the minWidth value to increase the minimum width
      cellRenderer: SquareBoxRenderer, // Use the custom cell renderer
    }));}
  };

  const colDefs1 = ((location?.state?.assetno!='' && location?.state?.assetno!=undefined)||assetNoForShowSchedule!=undefined) ?[
    { field: "assetNo", headerName: "Asset No", flex: 1, minWidth: 200, filter: "agTextColumnFilter", },
    { field: "assetdesc", headerName: "Asset Description", flex: 1, minWidth: 200, filter: "agTextColumnFilter", },
   { field: "taskcode", headerName: "Task Code", flex: 1, minWidth: 200, filter: "agTextColumnFilter", },
   { field: "locationcode", headerName: "User Location Code", flex: 1, minWidth: 200, filter: "agTextColumnFilter", },
   { field: "locationdesc", headerName: "User Location Description", flex: 1, minWidth: 200, filter: "agTextColumnFilter", },
     { headerName: 'JAN', children: generateWeeklyColumns(1,'jan')},
    { headerName: 'FEB', children: generateWeeklyColumns(2,'feb')},
    { headerName: 'MAR', children: generateWeeklyColumns(3,'mar')},
    { headerName: 'APR', children: generateWeeklyColumns(4,'apr')},
    { headerName: 'MAY', children: generateWeeklyColumns(5,'may')},
    { headerName: 'JUN', children: generateWeeklyColumns(6,'jun')},
    { headerName: 'JUL', children: generateWeeklyColumns(7,'jul')},
    { headerName: 'AUG', children: generateWeeklyColumns(8,'aug')},
    { headerName: 'SEP', children: generateWeeklyColumns(9,'sep')},
    { headerName: 'OCT', children: generateWeeklyColumns(10,'oct')},
    { headerName: 'NOV', children: generateWeeklyColumns(11,'nov')},
    { headerName: 'DEC', children: generateWeeklyColumns(12,'dec')},
  ]:[
   { field: "locationcode", headerName:"User Location Code", flex: 1, minWidth: 300, filter: "agTextColumnFilter", },
   { field: "locationdesc", headerName:"User Location Description", flex: 1, minWidth: 300, filter: "agTextColumnFilter", },  
   { field: "taskcode", headerName:"Task Code", flex: 1, minWidth: 200, filter: "agTextColumnFilter", },
    { headerName: 'JAN', children: generateWeeklyColumns(1,'jan')},
    { headerName: 'FEB', children: generateWeeklyColumns(2,'feb')},
    { headerName: 'MAR', children: generateWeeklyColumns(3,'mar')},
    { headerName: 'APR', children: generateWeeklyColumns(4,'apr')},
    { headerName: 'MAY', children: generateWeeklyColumns(5,'may')},
    { headerName: 'JUN', children: generateWeeklyColumns(6,'jun')},
    { headerName: 'JUL', children: generateWeeklyColumns(7,'jul')},
    { headerName: 'AUG', children: generateWeeklyColumns(8,'aug')},
    { headerName: 'SEP', children: generateWeeklyColumns(9,'sep')},
    { headerName: 'OCT', children: generateWeeklyColumns(10,'oct')},
    { headerName: 'NOV', children: generateWeeklyColumns(11,'nov')},
    { headerName: 'DEC', children: generateWeeklyColumns(12,'dec')},
  ];
  const fetchOptions = async () => {
    try {
     setLoading(true);
      let schedule = null;
      if ((serviceType?.value === 'FEMS'||location?.state?.service==='FEMS') && routineId) {
        schedule = await RoutineInspectionRepository.getRIShowSchedule(routineId);
        if (schedule?.data?.length > 0) {
          const formattedData = schedule?.data?.map(item => {
            return {
              ...item,

            };
          });
          setGetData(formattedData);
        }
      } else if ((serviceType?.value === 'BEMS'||location?.state?.service==='BEMS')  && routineId) {
        schedule = await RoutineInspectionRepository.getBemsRIShowSchedule(routineId);
         if (schedule?.data?.length > 0) {
           const formattedData = schedule?.data?.map(item => {
             return {
               ...item,
                };
           });
           setGetData(formattedData);        
       }
    }
   
    }
    catch (e) {
      console.log(e);
    }
    finally{
      setLoading(false);
    }
  }
  useEffect(() => {
    fetchOptions();

  }, [])

  useEffect(() => {
    if(serviceType?.value === 'FEMS'){
     if (getData !== null && getData.length > 0 && getData !== undefined) {
        const targetDates =getData?.map((item) => {
          const date = parseISO(item?.targetdate);
          const formattedDate = format(date, 'yyyy-MM-dd');
          return formattedDate
        });
        let obj=assetdeatils!=undefined?{ assetNo:assetdeatils?.label,assetdesc:assetdeatils?.assetdesc,taskcode:taskCode, targetDates: targetDates.join(',') }:{locationdesc:getData[0]?.locationdesc,locationcode:getData[0]?.locationcode,taskcode:taskCode, targetDates: targetDates.join(',') }
      setAllRowData([{...obj}]);
   }
  }
  else{
    if (getData !== null && getData.length > 0 && getData !== undefined) {
        const targetDates =getData?.map((item) => {
          const date = parseISO(item?.targetdate);
          const formattedDate = format(date, 'yyyy-MM-dd');
          return formattedDate
        });
      // setAllRowData([{ assetNo:assetdeatils?.label,assetdesc:assetdeatils?.assetdesc,taskcode:taskCode, targetDates: targetDates.join(',') }]);
      let obj=assetdeatils!=undefined?{ assetNo:assetdeatils?.label,assetdesc:assetdeatils?.assetdesc,taskcode:taskCode, targetDates: targetDates.join(',') }:{locationdesc:getData[0]?.locationdesc,locationcode:getData[0]?.locationcode,taskcode:taskCode, targetDates: targetDates.join(',') }
      setAllRowData([{...obj}]);
    }
    }
  }, [getData])

  const handleDateSubmitForDaily = async (inputDates, Row) => {
    if (!inputDates) return [];
    
    const dates = inputDates.split(',').map(dateStr => parseISO(dateStr.trim()));
    const today = new Date();
    const updatedRow = { ...Row,locationcode:getData[0].locationcode,locationdesc:getData[0].locationdesc };

    
    await Promise.all(dates.map(async (date) => {
      const month = date.getMonth() + 1;
      const year = date.getFullYear();
      const startDate = startOfMonth(new Date(year, month - 1));
      const endDate = endOfMonth(new Date(year, month - 1));
      
      // Use eachDayOfInterval for daily intervals
      const days = eachDayOfInterval({ start: startDate, end: endDate });
      
      // Find the day number within the month
      const dayNumber = days.map((day, index) => {
        if (isSameDay(day, date)) {
          return index + 1;  // Return the day number in the interval
        }
        return null; // Return null if the date doesn’t match this day
      }).find(num => num !== null); // Get the non-null value (correct day number)
    
      const color = date > today
        ? 'linear-gradient(to right, red 25%, lightcoral 25%)'
        : 'linear-gradient(to right, green 25%, lightgreen 25%)';
    
      updatedRow[`${format(date, 'MMM').toLowerCase()}_day${dayNumber}`] = { date, color };
    }));
    return updatedRow;
  };
  const handleDateSubmitForWeeksAndMonths = async ( inputDates, Row) => {
    if ( !inputDates) return [];
    const dates = inputDates.split(',')?.map(dateStr => parseISO(dateStr.trim()));
    const today = new Date();
    // if (Row?.assetNo === inputAssetNo) {
      const updatedRow = { ...Row,locationcode:getData[0].locationcode,locationdesc:getData[0].locationdesc };
      dates.forEach(date => {
        const month = date.getMonth() + 1;
        const year = date.getFullYear();
        const startDate = startOfMonth(new Date(year, month - 1));
        const endDate = endOfMonth(new Date(year, month - 1));
        const weeks = eachWeekOfInterval({ start: startDate, end: endDate }, { weekStartsOn: 1 });
        let weekNumber = 0;
        weeks.forEach((weekStart, index) => {
          if (date >= weekStart && date < (index + 1 < weeks.length ? weeks[index + 1] : endDate)) {
            weekNumber = index + 1;
          }
        });

        const color = date > today ? 'linear-gradient(to right, red 25%, lightcoral 25%)' : 'linear-gradient(to right, green 25%, lightgreen 25%)'; // Determine the color based on date comparison
        updatedRow[`${format(date, 'MMM').toLowerCase()}_week${weekNumber}`] = { date, color }; // Save both date and color
      });
      return updatedRow;   
    // }
  }
  useEffect(() => {
    const fetchData = async () => {
     let results;
      if (!allRowData) return;
      if(periodForShowSchedule==="Daily"){
       results = await Promise.all(allRowData.map(async (item) => {
        const updatedRows = await handleDateSubmitForDaily( item?.targetDates, item);
        return updatedRows;
      }));}
      else{
        results = await Promise.all(allRowData.map(async (item) => {
          const updatedRows = await handleDateSubmitForWeeksAndMonths( item?.targetDates, item);
          return updatedRows;
        }));
      }
      // Flatten the results array as `handleDateSubmit` returns an array
      const flattenedResults = results.flat();
      setRowData(flattenedResults);
    };

    fetchData();
  }, [allRowData]);

  const handleGridRefresh = () => {
    fetchOptions();
  }

  const handleCancel = () => {
      navigate(-1, { replace: true });
  };

  return (<>
    <PageLoader open={loading} />
    <DefaultCard>
      <Grid container spacing={2}>
        <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Grid item xs={12} md={4} sx={{ display: 'flex', justifyContent: 'center', marginTop: '5px' }}>
            <Typography variant='h2'>Today,      {format(new Date(), 'dd MMM, yyyy')}</Typography>
          </Grid>
          <Grid item xs={12} md={2} sx={{ display: 'flex', justifyContent: { xs: 'flex-end', md: 'flex-end' }, marginTop: '10px' }}>
            <Box
              sx={{
                width: 15, // width of the box in pixels
                height: 15, // height of the box in pixels
                backgroundColor: 'green', // green background color
                marginRight: 1,
                marginTop: '1px'
              }}
            />
            <span>Completed</span>
          </Grid>
          <Grid item xs={12} md={1} sx={{ display: 'flex', justifyContent: { xs: 'flex-end', md: 'flex-end' }, marginTop: '10px' }}>
            <Box
              sx={{
                width: 15, // width of the box in pixels
                height: 15, // height of the box in pixels
                backgroundColor: 'red', // red background color
                marginRight: 1,
                marginTop: '1px'
              }}
            />
            <span>Pending</span>
          </Grid>
          <Grid item xs={12} md={2} sx={{ display: 'flex', justifyContent: 'flex-start', marginBottom: '10px' }}>
            {/* <RefreshExportButtons exportFunction={() => { }} data={rowData}   title='RI Show Schedule' refData={gridApi} handleRefresh={handleGridRefresh} /> */}
            <RefreshExportButtons exportFunction={() => { }} formattedData={rowData} formattedHeaders={colDefs1} exportData={rowData} title='RI Show Schedule' refData={gridApi} handleRefresh={handleGridRefresh}  enablePDF = {false} />
          
          </Grid>
        </Grid>

        <Grid item xs={12} md={12}>
          <CustomAgGrid
            ref={gridApi}
            setGridApi={setGridApi}
            rows={rowData}
            columns={colDefs1}
            disableToolTip={true}
            // disableFilter={true}
            frameworkComponents={{ squareBoxRenderer: SquareBoxRenderer }} // Register the custom cell renderer
          />
        </Grid>
        
        <Grid item xs={12} md={12}
            sx={{
              marginTop: "30px",
              display: "flex",
              justifyContent: "flex-end",
            }}>

<ActionButtons
         handleCancel={handleCancel}
        isView={true}
      />
</Grid>
      </Grid>
    </DefaultCard></>
  );
}

export default RoutineInspectionShowSchedule;
